import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Divider, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
import _ from 'lodash';
import { CheckIcon, PenMenuIcon } from 'src/Icons';
import { DrawerServicesCategoryIcon } from "src/Icons/DrawerServicesCategoryIcon";
import { DrawerServiceSubctagoryIcon } from "src/Icons/DrawerServiceSubctagoryIcon";
import { EmployeeArrowRight } from "src/Icons/EmployeeArrowRight";
import { FolderArrowIcon } from "src/Icons/FolderArrowIcon";
import { FolderCheckIcon } from "src/Icons/FolderCheckIcon";
import { closeDrawer } from 'src/store/reducers/drawerSlice';
import { setSelectedStudio } from 'src/store/reducers/selectedStudioSlice';
import { resetSelectedRow } from 'src/store/reducers/tableSlice';

interface CustomRightDrawerServicePanelProps{
    location: "popup" | "drawer";
    chosenCat?: null | number;
    chosenSubCat?: null | number;
    setChosenCat?: (value: any) => void;
    setChosenSubCat?: (value: any) => void;
    categoriesList: Array<any>;
    rowData?: { services: [] };
}

export const RightDrawerServicePanel = ({
  location,
  chosenCat,
  chosenSubCat,
  setChosenCat,
  setChosenSubCat,
  categoriesList,
  rowData,
}:CustomRightDrawerServicePanelProps) => {

  const dispatch = useDispatch();

  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const [selectedCat, setSelectedCat] = useState<number | null>(null);
  const [selectedSubcat, setSelectedSubcat] = useState<number | null>(null);

  const handleSelectStudio = () => {
    dispatch(resetSelectedRow());
    dispatch(closeDrawer());
    dispatch(setSelectedStudio(rowData));
  };

  const handleCategoryClick = (newValue: any) => {
    setSelectedCat(selectedCat === newValue ? null : newValue);
    setSelectedSubcat(null);
  };

  const handleSubcatClick = (newValue: any) => {
    setSelectedSubcat(selectedSubcat === newValue ? null : newValue);
  };

  const handleItemClick = (index: any) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const handlePopupCatSelection = (newValue: number, index: any) => {
    setChosenCat && setChosenCat( chosenCat === newValue ? null : newValue)
    setChosenSubCat && setChosenSubCat(null)
    handleItemClick(index);
  }

  const handlePopupSubCatSelection = (newValue: number) => {
    setChosenSubCat && setChosenSubCat(chosenSubCat === newValue ? null : newValue)
  }

  const renderCategoriesForPopup = () => (
    <List>
      {categoriesList?.map((category, index) => (
        <div key={index}>
          {
            index !== 0 &&
            (chosenCat !== category.id && chosenCat !== categoriesList[index - 1]?.id) &&
            <Divider
              component="li"
              variant="middle"
            />
          }
          <ListItem
            onClick={() => handlePopupCatSelection(category.id, index)}
            sx={{
              flexDirection: "column",
              alignItems: "flex-start",
              backgroundColor: chosenCat === category.id ? "#FFF8FA" : "transparent",
              cursor: 'pointer',
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  width: "75%",
                  color: chosenCat === category.id ? "#BF295C" : "black",
                }}
              >
                {chosenCat === category.id ? (
                  <FolderCheckIcon
                    sx={{
                      width: "18px",
                      height: "18px",
                      marginRight: "5px",
                    }}
                  />
                ) : (
                  <FolderArrowIcon
                    sx={{
                      width: "18px",
                      height: "18px",
                      marginRight: "5px",
                    }}
                  />
                )}
                <ListItemText
                  primary={category.title}
                  sx={{
                    paddingLeft: "5px",
                  }}
                />
              </Box>
              <Typography
                sx={{
                  color: "#9D9D9D",
                  fontSize: "12px",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                }}
              >
                {`${category.children.length}
                  ${category.children.length === 1 ? "subcategory " : "subcategories"}
                `}
              </Typography>
            </Box>
          </ListItem>
          {openDropdownIndex === index && (
            <>
              {category.children.map((child: any, childIndex: number) => (
                <div key={childIndex}>
                  <ListItem
                    onClick={() => handlePopupSubCatSelection(child.id)}
                    sx={{
                      paddingLeft: "42px",
                      backgroundColor: "transparent",
                      cursor: 'pointer'
                    }}
                  >
                    {chosenSubCat === child.id ? (
                      <CheckIcon
                        sx={{
                          width: "18px",
                          height: "18px",
                          marginRight: "5px",
                          color: '#BF295C',
                        }}
                      />
                    ) : (
                      <EmployeeArrowRight
                        sx={{
                          width: "20px",
                          height: "20px",
                          marginRight: "5px",
                        }}
                      />
                    )}
                    <ListItemText
                      primary={child.title}
                      sx={{
                        marginLeft: "5px",
                        color: chosenSubCat === child.id ? '#BF295C' : 'black',
                      }}
                    />
                    <Typography
                      sx={{
                        color: "#9D9D9D",
                        fontSize: "12px",
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {`${child.services.length} service${child.services.length === 1 ? '' : 's'}`}
                    </Typography>
                    <InfoOutlinedIcon
                      sx={{
                        width: "14px",
                        height: "14px",
                        color: "#676767",
                        marginLeft: '6px'
                      }}
                    />
                  </ListItem>
                  {
                    childIndex !== category.children.length - 1 &&
                    <Box sx={{paddingLeft: "24px"}}>
                      <Divider
                        component="li"
                        variant="middle"
                      />
                    </Box>
                  }
                </div>
              ))}
            </>
          )}
        </div>
      ))}
    </List>
  );

  const renderServiceForDrawers = () => (
    <List>
      {categoriesList?.map((category, index) => {
        const servicesCount = _.sumBy(category.children, (el: any) => el.services.length) + category.services.length;
        return (
          <div key={index}>
            <ListItem
              onClick={() => handleCategoryClick(category.id)}
              sx={{
                paddingLeft: '0',
                paddingRight: '0',
                flexDirection: "column",
                alignItems: "flex-start",
                cursor: 'pointer',
              }}
            >
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
              >
                <Box
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    width: "75%",
                  }}
                >
                  <DrawerServicesCategoryIcon
                    sx={{
                      color: "#BF295C",
                      width: "18px",
                      height: "18px",
                      marginRight: "5px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                      paddingLeft: "5px",
                    }}
                  >
                    {category.title?.toUpperCase()}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "#BF295C",
                    fontSize: "14px",
                    fontWeight: "600",
                    whiteSpace: "nowrap",
                  }}
                >
                  {servicesCount}
                </Typography>
              </Box>
            </ListItem>

            <Divider component="li" />
            {selectedCat === category.id && (
              <>
                {category.children.map((child: any) => {
                  const servicesCount = child.services.length;

                  return (
                    <div key={child.id}>
                      <ListItem
                        onClick={() => handleSubcatClick(child.id)}
                        sx={{
                          backgroundColor: "transparent",
                          paddingRight: '0',
                          display: 'flex',
                          justifyContent: 'space-between',
                          cursor: 'pointer',
                        }}
                      >
                        <Box
                          sx={{
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <DrawerServiceSubctagoryIcon
                            sx={{
                              color: '#676767',
                              width: "18px",
                              height: "18px",
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "500",
                              whiteSpace: "nowrap",
                              paddingLeft: "5px",
                            }}
                          >
                            {child.title}
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            color: "#BF295C",
                            fontSize: "14px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {servicesCount}
                        </Typography>
                      </ListItem>

                      <Box sx={{paddingLeft: '16px'}}>
                        <Divider component="li"/>
                      </Box>

                      { selectedSubcat === child.id && child.services.length > 0 ?
                        <>
                          {child.services.map((item: any) => (
                            <div key={item.id}>
                              <ListItem
                                onClick={() => {}}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  backgroundColor: "transparent",
                                  paddingLeft: '38px',
                                  paddingRight: '0',
                                  cursor: 'default'
                                }}
                              >
                                <Box
                                  sx={{
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {item.title}
                                  </Typography>
                                </Box>
                              </ListItem>

                              <Box sx={{paddingLeft: '36px'}}>
                                <Divider component="li"/>
                              </Box>
                            </div>
                          ))}
                        </>
                        : null
                      }
                    </div>
                  )
                })}
                {
                  category.services.length > 0 ? (
                    <>
                      <ListItem
                        onClick={() => handleSubcatClick(-1)}
                        sx={{
                          backgroundColor: "transparent",
                          paddingRight: '0',
                          display: 'flex',
                          justifyContent: 'space-between',
                          cursor: 'pointer',
                        }}
                      >
                        <Box
                          sx={{
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <DrawerServiceSubctagoryIcon
                            sx={{
                              color: '#676767',
                              width: "18px",
                              height: "18px",
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "500",
                              whiteSpace: "nowrap",
                              paddingLeft: "5px",
                            }}
                          >
                            {'No subcategory'}
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            color: "#BF295C",
                            fontSize: "14px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {category.services.length}
                        </Typography>
                      </ListItem>
                      <Box sx={{paddingLeft: '16px'}}>
                        <Divider component="li"/>
                      </Box>

                      { selectedSubcat === -1 ?
                        <>
                          {category.services.map((item: any) => (
                            <div key={item.id}>
                              <ListItem
                                onClick={() => {}}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  backgroundColor: "transparent",
                                  paddingLeft: '38px',
                                  paddingRight: '0',
                                  cursor: 'default',
                                }}
                              >
                                <Box
                                  sx={{
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {item.title}
                                  </Typography>
                                </Box>
                              </ListItem>

                              <Box sx={{paddingLeft: '36px'}}>
                                <Divider component="li"/>
                              </Box>
                            </div>
                          ))}
                        </>
                        : null
                      }
                    </>
                  ) : null
                }
              </>
            )}
          </div>
        );
      })
      }
    </List>
  );

  return(
    <Box
      display="flex"
      sx={{
        padding: location === 'drawer' ? "0 16px 16px" : "0 0 32px",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          backgroundColor: "white",
          overflowY: "auto",
          maxHeight: '314px',
          flex: 1,
          borderRadius: "6px",
          padding: location === 'drawer' ? '16px 16px 24px' : '',
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
        }}
      >
        { location === 'drawer' &&
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              flex: 1,
              marginBottom: "24px",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Services
            </Typography>
            <IconButton
              onClick={handleSelectStudio}
              sx={{
                width: "16px",
                height: "16px",
                color: "#BF295C",
                fontSize: "16px",
              }}
              disableRipple
            >
              <PenMenuIcon fontSize="inherit" />
            </IconButton>
          </Box>
          {/*<Box*/}
          {/*  sx={{*/}
          {/*    display: "flex",*/}
          {/*    justifyContent: "space-between",*/}
          {/*    alignItems: "center",*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Typography*/}
          {/*    sx={{*/}
          {/*      textTransform: "uppercase",*/}
          {/*      fontSize: "12px",*/}
          {/*      color: "#828282",*/}
          {/*    }}*/}
          {/*  >*/}
          {/*        Service*/}
          {/*  </Typography>*/}
          {/*  <Typography*/}
          {/*    sx={{*/}
          {/*      textTransform: "uppercase",*/}
          {/*      fontSize: "12px",*/}
          {/*      color: "#828282",*/}
          {/*    }}*/}
          {/*  >*/}
          {/*        */}
          {/*  </Typography>*/}
          {/*</Box>*/}
        </>
        }

        {location === 'popup' ? renderCategoriesForPopup() : renderServiceForDrawers()}

      </Box>
    </Box>
  )
}
